import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=852f351a&scoped=true"
import script from "./authentication.vue?vue&type=script&lang=js"
export * from "./authentication.vue?vue&type=script&lang=js"
import style0 from "./authentication.vue?vue&type=style&index=0&id=852f351a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852f351a",
  null
  
)

export default component.exports